import GHTable from './ghTable.vue'

export default GHTable


// WEBPACK FOOTER //
// ./src/components/GhTable/index.js